export const formatTablesStr = (tables: string[], maxTablesInStr: number) => {
  const formattedTablesArr = tables.map((table) => `№${table}`)

  if (formattedTablesArr.length > maxTablesInStr) {
    return `${formattedTablesArr.slice(0, maxTablesInStr).join(', ')}...`
  } else {
    return formattedTablesArr.join(', ')
  }
}
